
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 22 16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#FFF","d":"M0 0h22v16H0z"}}),_c('g',{attrs:{"fill":"#0065BD"}},[_c('path',{attrs:{"d":"M6 0h4v16H6z"}}),_c('path',{attrs:{"d":"M0 6h22v4H0z"}})]),_c('g',{attrs:{"fill":"#ED2939"}},[_c('path',{attrs:{"d":"M7 0h2v16H7z"}}),_c('path',{attrs:{"d":"M0 7h22v2H0z"}})])])
          )
        }
      }
    